type PlanBuilderDisease = {
  disease:
    | "other"
    | "pcos"
    | "endometriosis"
    | "thyroid_disease"
    | "diminished_ovarian_reserve"
    | "primary_ovarian_insufficiency";
  category: "other" | "endocrine";
  other?: string;
};

type PlanBuilderAddress = {
  id?: string;
  postalCode: string;
};

const CONDITION_TO_DISEASE: Record<
  string,
  Pick<PlanBuilderDisease, "disease" | "category">
> = {
  "male-factor": { disease: "other", category: "other" },
  pcos: { disease: "pcos", category: "endocrine" },
  endometriosis: { disease: "endometriosis", category: "other" },
  thyroid_disease: { disease: "thyroid_disease", category: "endocrine" },
  diminished_ovarian_reserve: {
    disease: "diminished_ovarian_reserve",
    category: "other",
  },
  primary_ovarian_insufficiency: {
    disease: "primary_ovarian_insufficiency",
    category: "other",
  },
};

/** Preserve the existing primary-row ID so an ordinary save is an update. */
export function buildPlanBuilderAddress(
  postalCode: string | null,
  primaryAddressId?: string,
): PlanBuilderAddress[] | undefined {
  if (!postalCode) return undefined;
  return [
    {
      ...(primaryAddressId ? { id: primaryAddressId } : {}),
      postalCode,
    },
  ];
}

/** Map UI condition IDs to the canonical patient disease representation. */
export function buildPlanBuilderDiseases(
  conditions: string[],
): PlanBuilderDisease[] | undefined {
  const diseases = conditions.flatMap((condition) => {
    const mapped = CONDITION_TO_DISEASE[condition];
    if (!mapped) return [];
    return [
      {
        ...mapped,
        ...(mapped.disease === "other" ? { other: condition } : {}),
      },
    ];
  });
  return diseases.length > 0 ? diseases : undefined;
}
